import React from 'react';
import styles from './card.module.css';

const Card = ({ article, isHovered }) => {
  const convertDate = (date) => {
    const options = { day: '2-digit', month: '2-digit', year: 'numeric' };
    return new Date(date).toLocaleDateString('it', options).replace(/\//g, '.');
  };

  return (
    <div key={article._id} className="d-flex flex-row justify-content-center">
      <div
        className={`card border-0 h-100 rounded-0 text-white ${styles.eventNewsCard} ${
          isHovered ? styles.cardHovered : ''
        }`}
      >
        <img
          className={`card-img rounded-0 h-100 snf-img-obj-fit-cover ${
            isHovered ? styles.tansparentImage : ''
          }`}
          src={article.imgUrl}
          alt={`${article.type}_${article.title}`}
        />

        <div className={`card-img-overlay d-flex flex-column ${styles.cardBody}`}>
          <div className={`${isHovered ? 'my-auto' : 'mt-auto'}`} style={{ overflow: 'hidden' }}>
            <h5 className={`card-title snf-font-20 ${styles.articleHeader}`}>{article.title}</h5>
            <p className={`card-text font-weight-light snf-font-16 ${styles.articleSubheader}`}>
              {article.subtitle}
            </p>
            {isHovered && (
              <p className={`card-text font-weight-light snf-font-14 ${styles.articleBody}`}>
                {article.body}
              </p>
            )}
            {!isHovered && (
              <p className="card-text font-weight-light snf-font-14">
                {convertDate(article.created_date)}
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export { Card };
